import type { ChangelogEntry } from "../types";

/**
 * VIB-2726. Administrasjon av grupper og mappetilganger.
 *
 * `minRole: "admin"` på seksjonen: skjermen ligger under Innstillinger →
 * Tilganger og roller, og `role_menu_permissions` gir `innstillinger.tilganger`
 * kun til admin og superadmin. Å fortelle ansatte om en skjerm de ikke kan
 * åpne, er verre enn å ikke fortelle dem noe.
 *
 * Flagget `feature_dokumentarkiv` gjelder arkivet, og tildelingen av mapper er
 * i dag det eneste gruppene brukes til.
 */
export const GRUPPER_2026_10: ChangelogEntry = {
  id: "2026-10-02-grupper",
  date: "2026-10-02",
  title: "Grupper kan opprettes og styres uten hjelp fra utvikler",
  summary:
    "Admin kan opprette grupper, legge til medlemmer og gi en gruppe lese- eller endretilgang til en mappe i arkivet — og se hvem som faktisk har tilgang, med kilden synlig per person.",
  sections: [
    {
      heading: "Tilganger",
      minRole: "admin",
      items: [
        {
          title: "Opprett grupper og styr medlemmene selv",
          kind: "nytt",
          body: "Under Innstillinger → Tilganger og roller finner du en ny fane, Grupper. Der oppretter du en gruppe, gir den et nytt navn, legger til og fjerner folk, og sletter den når den har gjort sitt. Samme skjerm ligger også i arkivet, bak knappen «Grupper og tilgang».",
        },
        {
          title: "Gi en gruppe tilgang til en mappe",
          kind: "nytt",
          body: "Velg mappe, og sett nivå per gruppe: ingen tilgang, kan lese, eller kan lese og endre. En gruppe gir tilgang i TILLEGG til rollekravet på mappa, så styret kan se styreprotokollene uten at alle ansatte gjør det.",
          featureFlag: "feature_dokumentarkiv",
        },
        {
          title: "«Hvem har tilgang» svarer med kilden per person",
          kind: "nytt",
          body: "Lista viser hver person som kan lese eller endre i mappa, og hvorfor: via rollen, eller via en navngitt gruppe. Ligger mappa under en annen mappe, vises også de som er med i en gruppe med tildeling her men som likevel stoppes av mappa over — merket blokkert, slik at en tildeling som ikke virker ikke ser ut som om den virker.",
          featureFlag: "feature_dokumentarkiv",
        },
        {
          title: "Loggen sier hvem som mistet tilgangen",
          kind: "nytt",
          body: "Oppretting, navnebytte, medlemsendringer og tildelinger logges med hvem som gjorde det. Slettes en gruppe, lagres et øyeblikksbilde av medlemmene og mappene den ga tilgang til, så spørsmålet «hvem mistet tilgang da den gruppa ble slettet» kan besvares i ettertid.",
        },
      ],
    },
  ],
};
